import React from "react";
import { ReactComponent as CommunitySvg } from "../../assets/icons/community.svg";

export default function CommunityIcon({ size = 20, className = "" }) {
  const iconSize = typeof size === "number" ? `${size}px` : size;

  return (
    <CommunitySvg
      className={className}
      aria-hidden="true"
      focusable="false"
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "-0.125em",
        flexShrink: 0,
      }}
    />
  );
}
